import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';

const {
  REQUEST_GET_NOTE_TEMPLATE,
  SUCCESS_GET_NOTE_TEMPLATE,
  FAILURE_GET_NOTE_TEMPLATE,
  LOADING_GET_NOTE_TEMPLATE,
} = dailySessionNotes;

function* getNoteTemplate(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_NOTE_TEMPLATE });

    const response = yield call(dailySessionNotesService.getPatientNotesTemplate, action.uuid);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_NOTE_TEMPLATE, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_NOTE_TEMPLATE, payload: error });
  }
}

function* getNoteTemplateSaga() {
  yield takeEvery(REQUEST_GET_NOTE_TEMPLATE, getNoteTemplate);
}

export default getNoteTemplateSaga;
